<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="会员ID：" prop="member_id">
                <span>{{model.member_id}}</span>
            </el-form-item>
            <el-form-item label="会员编号：" prop="member_code">
                <span>{{model.member_code}}</span>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <span>{{model.cellphone}}</span>
            </el-form-item>
            <el-form-item label="等级：" prop="level">
                <span>{{model.level}}</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <span>{{model.state}}</span>
            </el-form-item>
            <el-form-item label="已结算：" prop="balance_settled">
                <span>{{model.balance_settled}}</span>
            </el-form-item>
            <el-form-item label="本期结算：" prop="balance_ready">
                <span>{{model.balance_ready}}</span>
            </el-form-item>
            <el-form-item label="等待结算：" prop="balance_wait">
                <span>{{model.balance_wait}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'promotionMemberInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                member_code: '',
                name: '',
                cellphone: '',
                level: '',
                state: '',
                balance_settled: '',
                balance_ready: '',
                balance_wait: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/promotionmember/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>